import styled from '@emotion/styled';
import React from 'react';
import TextField from '@mui/material/TextField';
import Button from '@mui/material/Button';
import mainContext from '../../../contexts/mainContext';
import CloseIcon from '@mui/icons-material/Close';
import { updateAdminProfileController } from '../../../Controllers/Auth';
import { checkAvailability } from '../../../utils';
import Avatar from '@mui/material/Avatar';
import { __constants, __snackBarSeverity, __snackBarText } from '../../../constants';
import LoadingButton from '@mui/lab/LoadingButton';

const AdminProfile = ({ setOpen }) => {
    const { setCanvasTitle, loginUserDetails, setLoginUserDetails,setPageload} = React.useContext(mainContext);
    const [editable, setEditable] = React.useState(false);
    const { setSnackBar } = React.useContext(mainContext);
    const [buttonLoader, setButtonLoader] = React.useState(false);
    const [profilePicUrl, setProfilePicUrl] = React.useState(__constants.baseurl + "/" + loginUserDetails.profilePicture)


    const handleUpdate = async () => {
        const file = document.getElementById("profile-picture").files;
        const firstName = document.getElementById("firstName").value
        const lastName = document.getElementById("lastName").value
        const email = document.getElementById("email").value
        const mobileNo = document.getElementById("mobileNo").value
        if (firstName === "" || lastName === "" || email === "" || mobileNo === "") {
            return alert("You can not empty any details");
        }
        const formdata = new FormData();
        formdata.append("firstName", firstName)
        formdata.append("lastName", lastName)
        formdata.append("email", loginUserDetails.email)
        formdata.append("mobileNo", mobileNo)
        try {
            if (file && file.length !== 0) {
                if (!checkAvailability(file[0].type)) { return alert("Unsupported File") }
                formdata.append("profile-picture", file[0]);
            }
        } catch (error) {
         return  alert(error)
        }
        setPageload(true)
        const res = await updateAdminProfileController(formdata);
        setPageload(false)
        if (res && res.status === 500) {
            setButtonLoader(false);
            return setSnackBar({
                status: true,
                text: __snackBarText.internalServerError,
                severity: __snackBarSeverity.error
            })
        }
        if (res.data.status !== 200) {
            setButtonLoader(false);
            return setSnackBar({
                status: true,
                text: res.data.errors[0].message || __snackBarText.unKnownError,
                severity: __snackBarSeverity.error
            })
        }
        setLoginUserDetails(res.data.data);
        setOpen(false);
        setSnackBar({
            status: true,
            text: "Profile updated successfully",
            severity: __snackBarSeverity.success
        });
    }

    const handlePictureOnChange = () => {
        const objectUrl = URL.createObjectURL(document.getElementById("profile-picture").files[0])
        setProfilePicUrl(objectUrl)
    }

    React.useEffect(() => {
        setCanvasTitle("Admin profile");
        // eslint-disable-next-line
    }, [])
    return (
        <>
            <Container>
                <Header>
                    <h4>Admin profile</h4>
                    <CloseIcon className='pointer' onClick={() => { setOpen(false) }} />
                </Header>
                {
                    Object.keys(loginUserDetails).length > 0 ?
                        <>
                            <Body>
                                <TextField fullWidth id='firstName' label="First name" defaultValue={loginUserDetails.firstName} className='input' variant='standard' disabled={!editable} />
                                <TextField fullWidth id='lastName' label="Last name" defaultValue={loginUserDetails.lastName} className='input' variant='standard' disabled={!editable} />
                                <TextField disabled={true} fullWidth id='email' label="Email" defaultValue={loginUserDetails.email} className='input' variant='standard' />
                                <TextField type="number" id='mobileNo' fullWidth label="Phone number" defaultValue={loginUserDetails.mobileNo} className='input' variant='standard' disabled={!editable} />
                                <h5>Profile picture</h5>
                                <div style={{
                                    margin: "1rem 0",
                                    display: "flex",
                                    alignItems: "center",
                                    columnGap: "1rem"
                                }}>
                                    <Avatar
                                        alt={loginUserDetails.firstName}
                                        src={profilePicUrl}
                                        sx={{ width: 40, height: 40 }}
                                        style={{
                                            marginLeft: "1rem",
                                            marginTop: "0.4rem"
                                        }}
                                    />
                                    <Button variant="contained" size='small' onClick={() => { document.getElementById("profile-picture").click() }} disabled={!editable}>change profile</Button>
                                </div>
                                <TextField
                                    style={{
                                        display: "none"
                                    }}
                                    id='profile-picture'
                                    fullWidth
                                    type="file"
                                    disabled={!editable}
                                    onInput={handlePictureOnChange}
                                />
                                <Actions>
                                    <Button variant="contained" className='button' disabled={editable} onClick={() => { setEditable(true) }}>Edit profile</Button>
                                    <LoadingButton
                                        loading={buttonLoader}
                                        variant="outlined"
                                        className='button'
                                        disabled={!editable}
                                        onClick={handleUpdate}
                                    >
                                        Update profile
                                    </LoadingButton>
                                </Actions>
                            </Body>
                        </>
                        :
                        <></>
                }
            </Container>
        </>
    )
}
const Container = styled("div")`
    height: 100%;
    width: 25vw;
    display: flex;
    flex-direction: column;
    padding: 1rem;
    overflow: hidden;
    min-width:300px;
    .input{
        margin-bottom: 5%;
    }
    .button{
      border-radius: 10px;
      width: 100%;
      text-transform: unset;
    }
    .profile_img_div{
        height: 30%;
    }
`;

const Header = styled("div")`
    width: 100%;
    display: flex;
    justify-content: space-between;
    align-items: center;
    h4{
        font-weight: 900;
        font-size: 120%;
    }
    padding-bottom: 0.7rem;
    border-bottom: 1px solid var(--card-border);
`;

const Body = styled("div")`
    margin-top: 1rem;
    height: 100%;
    width: 100%;
    overflow-y: auto;
    overflow-x: hidden;
`;

const Actions = styled("div")`
    padding-top: 1rem;
    width: 90%;
    margin: auto;
    display: flex;
    flex-direction: column;
    align-items: center;
    row-gap: 1rem;
    button{
        padding-left: 1px;
        padding-right: 1px;
    }
`;

export default AdminProfile